const TitleEnum = Object.assign({
  DR: { name: 'Dr.', value: 'Dr.' },
  DR_MED: { name: 'Dr. med.', value: 'Dr. med.' },
  PROF_DR: { name: 'Prof. Dr.', value: 'Prof. Dr.' },
  PROF: { name: 'Prof.', value: 'Prof.' },
});

const OnboardingTitleEnum = Object.assign({
  DR: { name: 'Dr.', value: 'Dr.' },
  MR: { name: 'Mr.', value: 'Mr.' },
  MS: { name: 'Ms.', value: 'Ms.' },
  MRS: { name: 'Mrs.', value: 'Mrs.' },
  PROF: { name: 'Prof.', value: 'Prof.' },
});

const NULL_OPTION = { name: 'Null', value: null };

Object.freeze(TitleEnum);

function getEnumAsArray(titleEnum) {
  return [NULL_OPTION, ...Object.keys(titleEnum)
    .map(key => ({
      name: titleEnum[key].name,
      value: titleEnum[key].value,
    }))];
}

export const titlesArray = getEnumAsArray(TitleEnum);
export const onboardingTitlesArray = getEnumAsArray(OnboardingTitleEnum);

export default TitleEnum;



// WEBPACK FOOTER //
// ./src/enum/user/Title.js